import log from 'loglevel'

/**
 * Shared debug/verbose-mode flag (`REACT_APP_DEBUG_LOG=1`). Beyond raising the
 * log level (see {@link getLogger}), UI code uses this to opt into extra,
 * developer-facing detail — e.g. the raw ontology term URI in file tooltips.
 */
export function isDebugLogEnabled(): boolean {
  return process.env.REACT_APP_DEBUG_LOG === '1'
}

export function getLogger() {
  const env = (process.env.REACT_APP_ENV || process.env.ENV || process.env.NODE_ENV || 'development').toUpperCase()
  const debugEnabled = isDebugLogEnabled()

  if (debugEnabled) {
    log.setLevel(log.levels.DEBUG)
  } else if (env === 'PROD' || env === 'PRODUCTION') {
    // In production, keep logs minimal
    log.setLevel(log.levels.WARN)
  } else {
    // In non-prod, prefer info-level by default
    log.setLevel(log.levels.INFO)
  }
  return log
}
